export const defaultTeamOption = { value: 'all', name: 'All Teams' };
export const defaultSelectedTeamOption = { value: 'selected', name: 'Selected Teams' };

export const statuses = {
  Indefinite: 'Indefinite',
  Expired: 'Expired',
  Expiring: 'Expiring',
  Valid: 'Valid',
} as const;

export const defaultStatusOptions = [
  { value: statuses.Valid, name: 'Valid' },
  { value: statuses.Expiring, name: 'Expiring' },
  { value: statuses.Expired, name: 'Expired' },
];

export const MATCH_MODES = {
  hasAny: 'has_any',
  hasAll: 'has_all',
  hasNone: 'has_none',
} as const;

export type MatchMode = (typeof MATCH_MODES)[keyof typeof MATCH_MODES];

export const matchModeOptions: { value: MatchMode; title: string }[] = [
  { value: MATCH_MODES.hasAny, title: 'Has any of these' },
  { value: MATCH_MODES.hasAll, title: 'Has all of these' },
  { value: MATCH_MODES.hasNone, title: 'Has none of these' },
];

export const matchModeSummaryLabel: Record<MatchMode, string> = {
  [MATCH_MODES.hasAny]: 'has any of',
  [MATCH_MODES.hasAll]: 'has all of',
  [MATCH_MODES.hasNone]: 'has none of',
};
